import { QualityPercentageWidget } from './percentage/qualityPercentage/qualityPercentage.widget';
import { GaugeDefaultBands } from './percentage/GaugeColor';
import { QualityId, QualityWidgetType } from '../models/';
import { IWidgetConfiguration } from './models';

export function createQualityGaugeWidget(type: string, config?: IWidgetConfiguration): QualityPercentageWidget {
    let localConfig;
    switch (type) {
        case 'invalidKPIsGauge':
            localConfig = {
                bands: GaugeDefaultBands.getBands('invalid KPIs'),
                qualityId: QualityId.Invalid,
                qualityWidgetType: QualityWidgetType.PercentageOfInvalidKPIGauge,
                name: 'Percentage of invalid KPIs'
            };
            break;
        case 'missingGauge':
            localConfig = {
                bands: GaugeDefaultBands.getBands('missing values'),
                qualityId: QualityId.Missing,
                qualityWidgetType: QualityWidgetType.PercentageOfMissingGauge,
                name: 'Percentage of missing values'
            };
            break;
        case 'percentageOfBadValuesGauge':
            localConfig = {
                bands: GaugeDefaultBands.getBands('bad tags'),
                qualityId: QualityId.Bad,
                qualityWidgetType: QualityWidgetType.PercentageOfBadValuesGauge,
                name: 'Percentage of bad tags'
            };
            break;
        case 'percentageOfFlatGauge':
            localConfig = {
                bands: GaugeDefaultBands.getBands('flat tags'),
                qualityId: QualityId.Flat,
                qualityWidgetType: QualityWidgetType.PercentageOfFlatGauge,
                name: 'Percentage of flat tags'
            };
            break;
        case 'percentageOfOutOfRangeGauge':
            localConfig = {
                bands: GaugeDefaultBands.getBands('out-of-range tags'),
                qualityId: QualityId.OutOfRange,
                qualityWidgetType: QualityWidgetType.PercentageOfOutOfRangeGauge,
                name: 'Percentage of out-of-range tags'
            };
            break;
        case 'percentageOfScatterGauge':
            localConfig = {
                bands: GaugeDefaultBands.getBands('scattered tags'),
                qualityId: QualityId.Scatter,
                qualityWidgetType: QualityWidgetType.PercentageOfScatterGauge,
                name: 'Percentage of scattered tags'
            };
            break;
        case 'qualityPercentage':
            localConfig = {};
            break;
        case 'suspiciousKPIsGauge':
            localConfig = {
                bands: GaugeDefaultBands.getBands('suspicious KPIs'),
                qualityId: QualityId.Suspicious,
                qualityWidgetType: QualityWidgetType.PercentageOfSuspiciousKPIGauge,
                name: 'Percentage of suspicious KPIs'
            };
            break;
    }
    const widget = !!localConfig
        ? new QualityPercentageWidget((Object as any).assign({}, localConfig, config)) // order of copy is important to override defualt parameters
        : null;
    return widget;
}